import { GROUPS, PREFIX_PROXY } from '@/service/apiConf';
import { deleteRes, get, patchJSON, postJSON, putJSON } from '@/service/request';
import { GetWorkloadListParams } from './deployment.api';

/** 请求参数与工作负载列表一样, 接口路径改变了 */
export const getDaemonSetList = (cluster: string, params: GetWorkloadListParams): Promise<any> =>
  get(`${PREFIX_PROXY.vapis(GROUPS.daemonset)}/daemonsets`, params);

export const getDaemonSetDetail = ({
  cluster,
  namespace,
  daemonset,
}: {
  cluster: string;
  namespace: string;
  daemonset: string;
}): Promise<any> =>
  get(`${PREFIX_PROXY.apis_v1(GROUPS.apps)}/namespaces/${namespace}/daemonsets/${daemonset}`);

export const postCreateDaemonSet = ({
  cluster,
  namespace,
  data,
  dryRun,
}: {
  cluster: string;
  namespace: string;
  data: any;
  dryRun?: string;
}): Promise<any> =>
  postJSON(`${PREFIX_PROXY.apis_v1(GROUPS.apps)}/namespaces/${namespace}/daemonsets`, data, {
    params: { dryRun },
  } as any);

export const putEditDaemonSet = ({
  cluster,
  namespace,
  daemonset,
  data,
}: {
  cluster: string;
  namespace: string;
  daemonset: string;
  data: any;
}): Promise<any> =>
  putJSON(
    `${PREFIX_PROXY.apis_v1(GROUPS.apps)}/namespaces/${namespace}/daemonsets/${daemonset}`,
    data,
  );

export const patchEditDaemonSet = ({
  cluster,
  namespace,
  daemonset,
  data,
}: {
  cluster: string;
  namespace: string;
  daemonset: string;
  data: any;
}): Promise<any> =>
  patchJSON(
    `${PREFIX_PROXY.apis_v1(GROUPS.apps)}/namespaces/${namespace}/daemonsets/${daemonset}`,
    data,
  );

export const deleteDaemonSet = ({
  cluster,
  namespace,
  daemonset,
}: {
  cluster: string;
  namespace: string;
  daemonset: string;
}): Promise<any> =>
  deleteRes(`${PREFIX_PROXY.apis_v1(GROUPS.apps)}/namespaces/${namespace}/daemonsets/${daemonset}`);

/** pods */
export const getDaemonSetPods = ({
  cluster,
  namespace,
  daemonset,
  params,
}: {
  cluster: string;
  namespace: string;
  daemonset: string;
  params?: any;
}): Promise<any> =>
  get(
    `${PREFIX_PROXY.vapis(GROUPS.daemonset)}/namespaces/${namespace}/daemonsets/${daemonset}/pods`,
    params,
  );
